import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Tabs, TabsList, TabsTrigger } from "../shadcn/ui/tabs";

const HTabsNavigation = ({
  tabs = [],
  defaultTab = "",
  onTabChange,
  className = "",
  showMobileDropdown = true,
  activeTabStyle = "data-[state=active]:bg-white data-[state=active]:text-gray-900",
  inactiveTabStyle = "data-[state=inactive]:text-gray-600",
  containerStyle = "bg-gray-200",
  value,
}) => {
  const history = useHistory();
  const location = useLocation();

  // Determine current tab based on URL path or default
  const getCurrentTab = () => {
    const currentPath = location.pathname;
    const matchedTab = tabs.find(tab => tab.route === currentPath);
    return matchedTab ? matchedTab.value : defaultTab;
  };

  // Handle tab change with routing or custom handler
  const handleTabChange = value => {
    const selectedTab = tabs.find(tab => tab.value === value);

    if (onTabChange) {
      // Use custom handler if provided
      onTabChange(value, selectedTab);
    } else if (selectedTab?.route) {
      // Default behavior: navigate to route
      history.push(selectedTab.route);
    }
  };

  if (!tabs.length) {
    return null;
  }

  const currentTab = typeof value !== "undefined" ? value : getCurrentTab();

  return (
    <div className={`mx-3 mt-4 mb-6 ${className}`}>
      <Tabs value={currentTab} onValueChange={handleTabChange} className="w-full">
        {/* Desktop View: Pill-style tabs */}
        <TabsList className={`hidden p-1 rounded-full md:inline-flex ${containerStyle}`}>
          {tabs.map(tab => (
            <TabsTrigger
              key={tab.value}
              value={tab.value}
              className={`px-4 py-1 text-sm font-medium text-center rounded-full transition-all min-w-24 ${activeTabStyle} ${inactiveTabStyle}`}
            >
              {tab.label}
            </TabsTrigger>
          ))}
        </TabsList>

        {/* Mobile View: Dropdown */}
        {showMobileDropdown && (
          <div className="md:hidden">
            <select
              value={currentTab}
              onChange={e => handleTabChange(e.target.value)}
              className="px-4 py-2 w-full text-sm font-medium text-gray-900 bg-white rounded-full border border-gray-300 shadow-sm"
            >
              {tabs.map(tab => (
                <option key={tab.value} value={tab.value}>
                  {tab.label}
                </option>
              ))}
            </select>
          </div>
        )}
      </Tabs>
    </div>
  );
};

export default HTabsNavigation;
